module.exports = __webpack_public_path__ + "static/media/team-member-3.a77c7e44.png";